import { createConfirmation } from "react-confirm";
import AddNewRecipeUnitConvertDialog from "./AddNewRecipeUnitConvertDialog";

export const showAddNewRecipeUnitConvertDialog = createConfirmation(AddNewRecipeUnitConvertDialog);
